import { render, staticRenderFns } from "./PhoneCode.vue?vue&type=template&id=0a3b5f54&scoped=true&"
import script from "./PhoneCode.vue?vue&type=script&lang=js&"
export * from "./PhoneCode.vue?vue&type=script&lang=js&"
import style0 from "./PhoneCode.vue?vue&type=style&index=0&id=0a3b5f54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b5f54",
  null
  
)

export default component.exports